<template>
    <app-header/>
</template>

<script>
import CookieBaker from "@/utils/CookieBaker";
import AppHeader from '@/components/header/AppHeader/AppHeader';
import storeLoaderMixin from '@/components/mixins/storeLoaderMixin.ts';
import allService from '@/services/all.service';
import { delayCall } from "@/utils/helper.functions";
export default {
    mixins: [storeLoaderMixin],
    components: {
        'app-header': AppHeader
    },
    created() {
        allService.load(({ menu, customer, recentOrders, location }) => {
            delayCall(() => {
				new Promise((resolve) => {
					this.categoriesLoader();
					resolve();
				}).then(() => {
					this.optionsLoader();
				}).then(() => {
					this.optionExceptionsLoader();
				}).then(() => {
					this.customerLoader();
				}).then(() => {
					this.locationLoader();
				}).then(() => {
				    this.setRecentOrders(recentOrders);  
                });
			});
        });
    }
}
</script>

<style lang='scss' scoped=true>
    @import 'bulma';

    .header{
        min-height: 73px;
    }
</style>



// WEBPACK FOOTER //
// src/components/header/InjectableHeader/InjectableHeader.vue